import { Button, message } from "antd";
import React, { useEffect } from "react";
import { YhBox } from "../../../../components/YhBox";
import { DescriptionColorEnum, IDescription } from "../../../../components/YhBox/Types";
import { BillDataTable } from "./DataTable";
import { PageHeader } from './PageHeader'
import { useBillMonitorModel } from "../billMonitorModel";
import { orgService } from "../../../base/org/orgService";
import { beService } from "../../../base/be/beService";
import { labelsType } from "../../../cash/pay/cashPayModel";
import { useGlobalModel } from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";



export const BillMonitor = () => {

    const {
        dataSource,
        selectedRowKeys,
        billSummaryData,
        setOrgDs,
        setBeDs,
        // setAppDs,
        // setPayMethodDs,
        setPayMethodLabels,
        setSelectedData,
        loadData,
        billMonitorExport,
        exportLoading,
    } = useBillMonitorModel(model => [model.billSummaryData, model.exportLoading])

    const { getSelectedDict } = useGlobalModel(() => []);

    useEffect(() => {
        loadData();

        let obj: labelsType = {}
        orgService.orgTreeDs({}).then(ds => setOrgDs(ds))
        beService.beDs({}).then(ds => setBeDs(ds))
        getSelectedDict(DictCodeEnmu.SETTLE_TYPE).forEach(item => {
            obj[item.value] = item.label
        })
        setPayMethodLabels(obj);
    }, []);



    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedData(selectedData)
    }, [selectedRowKeys]);

    const desc: IDescription[] = [
        {
            label: "状态差异",
            value: billSummaryData?.totalBillAmount ?? 0,
            color: DescriptionColorEnum.red
        },
        {
            label: "金额差异",
            value: billSummaryData?.totalWriteoffAmount?.toFixed(2) ?? 0.00,
            color: DescriptionColorEnum.red
        },

    ]

    const action = (
        <div>

            <YhAuth resCode={ResourceAuthEnum.BILL_S_EX}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    loading={exportLoading}
                    onClick={billMonitorExport}
                >
                    导出
                </Button>
            </YhAuth>
        </div>
    );

    return (
        <>
            <PageHeader />
            <YhBox title={action} descriptions={desc} >
                <BillDataTable />
            </YhBox>
        </>
    )
}